function SectionLayout({ children }) {
  return <div className="w-1/4 p-4 h-full min-h-0 flex flex-col gap-y-1 overflow-y-auto">{children}</div>;
}

export { SectionLayout };
